// symbols.js - Centralized symbol/emoji constants using Unicode escape sequences
// This avoids encoding issues when files are transferred or uploaded

export const SYMBOLS = {
  // Stars and ratings (decorative - using emojis)
  STAR_FILLED: '\u{2B50}',    // ⭐
  STAR_EMPTY: '\u2606',       // ☆
  
  // Geometric shapes (UI controls - keeping unicode)
  DIAMOND: '\u25C6',          // ◆
  DIAMOND_SMALL: '\u2666',    // ♦
  DIAMOND_OUTLINE: '\u25C7',  // ◇
  SQUARE: '\u25A0',           // ■
  SQUARE_OUTLINE: '\u25A1',   // □
  TRIANGLE_UP: '\u25B2',      // ▲
  TRIANGLE_DOWN: '\u25BC',    // ▼
  TRIANGLE_RIGHT: '\u25B6',   // ▶
  TRIANGLE_LEFT: '\u25C0',    // ◀
  CIRCLE: '\u25CF',           // ●
  CIRCLE_OUTLINE: '\u25CB',   // ○
  
  // Decorative (using emojis)
  SPARKLE: '\u2728',          // ✨
  SPARKLE_ALT: '\u{1F31F}',   // 🌟
  BULLET: '\u2022',           // •
  DIAMOND_BULLET: '\u25C8',   // ◈
  
  // Status indicators (decorative - using emojis)
  CHECK: '\u2713',            // ✓ (UI)
  CHECK_HEAVY: '\u2714',      // ✔ (UI)
  CROSS: '\u2717',            // ✗ (UI)
  CROSS_HEAVY: '\u2718',      // ✘ (UI)
  WARNING: '\u{26A0}\uFE0F',  // ⚠️
  SKULL: '\u{1F480}',         // 💀
  
  // Arrows (UI controls - keeping unicode)
  ARROW_LEFT: '\u2190',       // ←
  ARROW_RIGHT: '\u2192',      // →
  ARROW_UP: '\u2191',         // ↑
  ARROW_DOWN: '\u2193',       // ↓
  ARROW_ROTATE: '\u{1F504}',  // 🔄 (decorative)
  CHEVRON_LEFT: '\u2039',     // ‹
  CHEVRON_RIGHT: '\u203A',    // ›
  CHEVRON_UP: '\u2303',       // ⌃
  CHEVRON_DOWN: '\u2304',     // ⌄
  CHEVRON_LEFT_DOUBLE: '\u00AB', // «
  CHEVRON_RIGHT_DOUBLE: '\u00BB', // »
  
  // Corner decorations (UI - keeping unicode)
  CORNER_TL: '\u25E2',        // ◢
  CORNER_TR: '\u25E3',        // ◣
  CORNER_BL: '\u25E5',        // ◥
  CORNER_BR: '\u25E4',        // ◤
  
  // Emojis (decorative)
  BOOK: '\u{1F4D6}',          // 📖
  BOOK_CLOSED: '\u{1F4D5}',   // 📕
  BOOK_GREEN: '\u{1F4D7}',    // 📗
  CAMERA: '\u{1F4F7}',        // 📷
  PICTURE: '\u{1F5BC}\uFE0F', // 🖼️
  FILM: '\u{1F3AC}',          // 🎬
  LIGHTNING: '\u{26A1}',      // ⚡
  HOURGLASS: '\u{23F3}',      // ⏳
  CLOCK: '\u{1F550}',         // 🕐
  FLASK: '\u{1F9EA}',         // 🧪
  PALETTE: '\u{1F3A8}',       // 🎨
  
  // Miscellaneous
  INFINITY: '\u221E',         // ∞
  ELLIPSIS: '\u2026',         // …
  MIDDOT: '\u00B7',           // ·
  EM_DASH: '\u2014',          // —
  NUMBER_SIGN: '\u2116',      // №
};

// Helper function to safely get a symbol with fallback
export const getSymbol = (name, fallback = '?') => {
  return SYMBOLS[name] || fallback;
};

// Result type configurations using safe symbols
export const RESULT_CONFIGS = {
  perfect: {
    icon: SYMBOLS.STAR_FILLED,
    title: 'PERFECT TIMELINE',
  },
  altered: {
    icon: SYMBOLS.DIAMOND,
    title: 'ALTERED TIMELINE',
  },
  innovative: {
    icon: SYMBOLS.SPARKLE_ALT,
    title: 'INNOVATIVE TIMELINE',
  },
  rules_broken: {
    icon: SYMBOLS.WARNING,
    title: 'RULES BROKEN',
  },
  failed: {
    icon: SYMBOLS.CROSS,
    title: 'HISTORY UNCHANGED',
  },
  corrupted: {
    icon: SYMBOLS.SKULL,
    title: 'TIMELINE CORRUPTED',
  },
};

export default SYMBOLS;
